<template>
  <mdb-container class="gp-has-header text-left">
    <div v-if="notProdMessage" class="danger-color text-white p-2 mb-4">
      Danger! Although this is not a production environment, these <i>are</i> production AWS services!
    </div>
    <div v-if="!currentService">
      <mdb-card class="mb-4">
        <mdb-card-header>
          <h5>Manage a Service</h5>
        </mdb-card-header>
        <mdb-card-body>
          <div>
            <mdb-btn size="sm" icon="scale-balanced" @click="currentService='lb-targets'">Load Balancer Targets</mdb-btn>
            <mdb-btn size="sm" icon="video-plus" @click="currentService='jitsi'">Jitsi</mdb-btn>
            <mdb-btn size="sm" icon="users" @click="currentService='cognito'">Cognito</mdb-btn>
          </div>
        </mdb-card-body>
      </mdb-card>
      <mdb-card class="mb-4">
        <mdb-card-header>
          <h5>Services Overview
            <mdb-btn size="sm" rounded icon="recycle" @click="loadSummary">Refresh</mdb-btn>
          </h5>
        </mdb-card-header>
        <mdb-card-body v-if="summary">
          <mdb-card class="mb-4">
            <mdb-card-header>
              <h3>Logging</h3>
            </mdb-card-header>
            <mdb-card-body>
              <gp-select label="Current Level" :dataObj="summary" :possible-values="logLevels" :required="true"
                         propertyName="logLevel"/>
              <mdb-btn size="sm" rounded icon="save" @click="updateLogging">Update Level</mdb-btn>
            </mdb-card-body>
          </mdb-card>

          <mdb-row v-if="summary">
            <mdb-col class="mb-4" md="6" xl="6">
              <mdb-card class="mb-4">
                <mdb-card-header>
                  <h3>Live Servers</h3>
                </mdb-card-header>
                <mdb-card-body>
                  <div class="list-group">
                    <div clss="list-group-item" v-for="s in summary.activeInstances" :key="s.instanceId">
                      <h5>{{ s.name }}</h5>
                      <div>{{ s.instanceType }} - {{ s.instanceId }} at {{ s.publicIpAddress }}</div>
                      <div class="text-info">{{ s.state }}</div>
                      <hr/>
                    </div>
                  </div>
                </mdb-card-body>
              </mdb-card>
            </mdb-col>

            <mdb-col class="mb-4" md="6" xl="6">
              <mdb-card class="mb-4">
                <mdb-card-header >
                  <h3>Cold Servers</h3>
                </mdb-card-header>
                <mdb-card-body>
                  <div class="list-group">
                    <div clss="list-group-item" v-for="s in summary.inactiveInstances" :key="s.instanceId">
                      <h5>{{ s.name }}</h5>
                      <div>{{ s.instanceType }} - {{ s.instanceId }} <span v-if="s.publicIpAddress"> at
                        {{ s.publicIpAddress }}</span></div>
                      <div class="text-info">{{ s.state }}</div>
                      <hr/>
                    </div>
                  </div>
                </mdb-card-body>
              </mdb-card>
            </mdb-col>

          </mdb-row>
        </mdb-card-body>
      </mdb-card>
    </div>
    <balancer-targets v-if="currentService=='lb-targets'" @finished="currentService=null"/>
    <jitsi v-if="currentService=='jitsi'" @finished="currentService=null"/>
    <cognito v-if="currentService=='cognito'" @finished="currentService=null"/>

  </mdb-container>

</template>
<script>
import BalancerTargets from "./BalancerTargets";
import Jitsi from "./Jitsi";
import Cognito from "./Cognito";
import {
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardHeader,
  mdbCol,
  mdbContainer,
  mdbInput,
  mdbListGroup,
  mdbListGroupItem,
  mdbRow
} from 'mdbvue';
import api from "../../services/groupsPlaceApi";
import gpSelect from "../common/GPSelect";

export default {
  name: "admin-aws-console",
  display: "AWS Console",
  order: 1,
  components: {
    mdbContainer,
    mdbInput,
    mdbBtn,
    mdbCard,
    mdbCardHeader,
    mdbCardBody,
    mdbRow,
    mdbCol,
    mdbListGroup,
    mdbListGroupItem,
    BalancerTargets,
    Jitsi,
    Cognito,
    gpSelect
  },
  computed: {
    userDetails: function () {
      return this.$store.state.userDetails
    }
  },
  mounted() {
    if (process.env.NODE_ENV != "production") this.notProdMessage = true
    document.title = "AWS Services"
    this.loadSummary()
  },
  data() {
    return {
      currentService: null,
      notProdMessage: false,
      summary: null,
      logLevels: [
        {text: "Debug", value: "DEBUG"},
        {text: "Informational", value: "INFO"},
        {text: "Warning", value: "WARN"},
        {text: "Error", value: "ERROR"}
      ]
    }
  },
  methods: {
    loadSummary() {
      this.$store.dispatch("setExecuting", true)
      api.get("/aws/summary").then(
        (results) => {
          this.summary = results.data
        },
        (error) => {
          this.$notify.error({message: error.response.data})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    updateLogging() {
      this.$store.dispatch("setExecuting", true)
      api.get("/admin/logLevel/" + this.summary.logLevel).then(
        (results) => {
          this.$notify.success({message: "Log Level updated to " + this.summary.logLevel})
        },
        (error) => {
          this.$notify.error({message: error.response.data})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    }
  }

}
;
</script>
